import { useCallback, useEffect } from "react";

import { Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { useCloudinaryPhotoUpload } from "app/hooks/useCloudinaryPhotoUpload";
import { config } from "config";
import { PhotoUpload } from "ui/PhotoUpload/PhotoUpload";
import { DetailL, TitleM } from "ui/Typography/Typography";

const { CLOUDINARY_EQUIPMENT_TRACKING_FOLDER } = config.environment;

export function DocumentPhoto({
  onPhotosChanged: onPhotosChangedProp,
  fileName,
}: {
  onPhotosChanged: (photos: string[]) => void;
  fileName?: string;
}) {
  const intl = useIntl();

  const { uploadedPhotos, uploadPhoto, removePhoto } = useCloudinaryPhotoUpload(
    CLOUDINARY_EQUIPMENT_TRACKING_FOLDER,
    fileName,
  );

  const onPhotosChanged = useCallback(
    (photos: string[]) => {
      onPhotosChangedProp(photos);
    },
    [onPhotosChangedProp],
  );

  useEffect(() => {
    onPhotosChanged(uploadedPhotos.map((photo) => photo.src));
  }, [uploadedPhotos, onPhotosChanged]);

  return (
    <>
      <TitleM pt="s300" px="s200" pb="s200">
        {intl.formatMessage({
          id: "components.activities.transport-equipment.count-page.photo.title",
        })}
      </TitleM>
      <Box bg="white" borderRadius="sm" p="s200">
        {!fileName && (
          <DetailL color="grey.600" mb="s100" display="flex" alignItems="center" gap="s50">
            {intl.formatMessage({
              id: "components.activities.transport-equipment.count-page.photo.disabled.explanation",
            })}
          </DetailL>
        )}
        <PhotoUpload
          label={intl.formatMessage(
            {
              id: "pages.inbound.inbound-outbound.outbound-photo-upload.explanations.call-to-action",
            },
            { br: <br /> },
          )}
          onPhotoUpload={uploadPhoto}
          onPhotoRemove={removePhoto}
          uploadedPhotos={uploadedPhotos}
          maxPhotos={1}
          isDisabled={!fileName}
        />
      </Box>
    </>
  );
}
